import React from 'react';

/**
 * props:
 * - usages: [{ id, name }] — estratégias que usam o registro (monitor ou automação)
 */
function StrategyUsageBadge({ usages }) {
    if (!usages || usages.length === 0) return null;

    const title = usages.map(u => u.name).join(', ');
    const label = usages.length === 1
        ? usages[0].name
        : `${usages.length} estratégias`;

    return (
        <span
            className='badge bg-info text-dark ms-2'
            title={`Usado por: ${title}`}
            style={{ fontWeight: 'normal', maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', verticalAlign: 'middle' }}
        >
            🔗 {label}
        </span>
    );
}

export default StrategyUsageBadge;
